import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { Timer } from 'utils'

import { getElapsedSeconds } from '../../constants'

import styles from './index.css'

const renderUnit = (value, unit, useLeadingZero = false) => (
  <span>
    {value > 9 || !useLeadingZero ? value : `0${value}`}
    <em className={styles.unit}>{unit}</em>
  </span>
)

class ElapsedTime extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      elapsedSeconds: getElapsedSeconds(props.initialDate, props.finalDate),
      timer: new Timer(300, this.updateSeconds, 0),
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.paused) {
      state.timer.pause()
    } else {
      state.timer.resume()
      return {
        elapsedSeconds: getElapsedSeconds(props.initialDate, props.finalDate),
      }
    }
    return null
  }

  componentDidMount() {
    if (!this.props.paused) {
      this.state.timer.start()
    }
  }

  componentWillUnmount() {
    this.state.timer.stop()
  }

  updateSeconds = () =>
    this.setState({
      elapsedSeconds: getElapsedSeconds(this.props.initialDate, this.props.finalDate),
    })

  render() {
    const { className, hoursUnit, minutesUnit, secondsUnit, showHours, showMinutes, showSeconds } = this.props
    let { elapsedSeconds } = this.state
    let elapsedMinutes = Math.floor(elapsedSeconds / 60)
    const elapsedHours = Math.floor(elapsedMinutes / 60)

    if (showHours) {
      elapsedMinutes -= elapsedHours * 60
      elapsedSeconds -= elapsedHours * 60 * 60
    }

    if (showMinutes) {
      elapsedSeconds -= elapsedMinutes * 60
    }

    return (
      <div className={cn(styles.wrapper, className)}>
        {showHours && elapsedHours > 0 && renderUnit(elapsedHours, hoursUnit)}
        {showMinutes && elapsedMinutes > 0 && renderUnit(elapsedMinutes, minutesUnit, elapsedHours > 0)}
        {showSeconds && renderUnit(elapsedSeconds, secondsUnit, elapsedMinutes > 0)}
      </div>
    )
  }
}

ElapsedTime.propTypes = {
  initialDate: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]).isRequired,

  className: PropTypes.string,
  finalDate: PropTypes.instanceOf(Date),
  hoursUnit: PropTypes.string,
  minutesUnit: PropTypes.string,
  paused: PropTypes.bool,
  secondsUnit: PropTypes.string,
  showHours: PropTypes.bool,
  showMinutes: PropTypes.bool,
  showSeconds: PropTypes.bool,
}

ElapsedTime.defaultProps = {
  className: null,
  finalDate: null,
  hoursUnit: ':',
  minutesUnit: "'",
  paused: false,
  secondsUnit: '"',
  showHours: false,
  showMinutes: true,
  showSeconds: false,
}

export default ElapsedTime
